<template>
  <div class="panic-alert-main-view width-responsiveness">
    <SubHeaderV2
      class="sub-header"
      title="Alertas"
      icon-path="/static/images/icon-dashboard-alert-emergency.svg"
      @back="goBack"
    />

    <PanicAlertFilter />
   
    <tabs
      class="mb-0 mt-0"
      with-border
      :tabs="tabs"
      :tab-selected="panicAlertCurrentTab"
      @tabClicked="changeTab"
    />

    <PanicAlertDataTable class="mt-n6" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SubHeaderV2 from '@/components/common/SubHeaderV2.vue'
import Card from '@/components/Dashboard/Card.vue'
import CountIcon from '@/components/common/dataTable/CountIcon.vue'
import Spinner from '@/components/common/Spinner.vue'
import PanicAlertFilter from './PanicAlertFilter.vue'
import PanicAlertDataTable from './PanicAlertDataTable.vue'
import Tabs from '@/components/common/Tabs.vue'

export default {
  name: 'PanicAlertMainView',
  components: {
    SubHeaderV2,
    PanicAlertFilter,
    PanicAlertDataTable,
    CountIcon,
    Card,
    Spinner,
    Tabs
  },
  data() {
    return {
      minutes: 0,
      updateTime: new Date(),
      interval: null
    }
  },
  computed: {
    ...mapGetters([
      'panicAlertList',
      'isPanicAlertListStatusLoading',
      'panicAlertsTotal',
      'panicAlertCurrentTab',
      'panicAlertParams'
    ]),
    tabs() {
      return [
        { name: 'Resultados Críticos', key: 'TODOS', total: this.panicAlertsTotal ?? 0, tooltip: 'Clique aqui para filtrar o Status' },
      ]
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
    this.clearAllPanicAlertData()
  },
  methods: {
    ...mapActions(['clearAllPanicAlertData', 'changeTab']),
    goBack() {
      this.$router.push('/dashboard')
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../static/stylesheets/variables';

.panic-alert-main-view {
  margin-top: 150px;
  display: flex;
  flex-direction: column;
  gap: 1.5em;
}
:deep(.sub-header){
  i{
    margin-bottom: -1.3px;
  }
}
</style>
